import { ticketsApi, Ticket, Order } from './api/ticketsApi';

class TicketsService {
  // Get all user tickets
  async getTickets(): Promise<Ticket[]> {
    try {
      const response = await ticketsApi.getTickets();
      if (response && response.data && response.data.tickets) {
        return response.data.tickets;
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching tickets:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch tickets');
    }
  }

  // Get ticket by ID
  async getTicketById(id: string): Promise<Ticket | null> {
    try {
      const response = await ticketsApi.getTicketById(id);
      if (response && response.data && response.data.ticket) {
        return response.data.ticket;
      }
      return null;
    } catch (error: any) {
      console.error('Error fetching ticket:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch ticket');
    }
  }

  // Get all user orders
  async getOrders(): Promise<Order[]> {
    try {
      const response = await ticketsApi.getOrders();
      if (response && response.data && response.data.orders) {
        return response.data.orders;
      }
      return [];
    } catch (error: any) {
      console.error('Error fetching orders:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch orders');
    }
  }

  // Get order by ID
  async getOrderById(id: string): Promise<Order | null> {
    try {
      const response = await ticketsApi.getOrderById(id);
      if (response && response.data && response.data.order) {
        return response.data.order;
      }
      return null;
    } catch (error: any) {
      console.error('Error fetching order:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch order');
    }
  }
}

export const ticketsService = new TicketsService();




